module.exports = __webpack_public_path__ + "img/social-linkedin.582d6b26.svg";